import { useMemo } from "react";
import { useFirestore } from "@/hooks/firestore/core/useFirestore";
import { casinoCategory } from "@/features/casino/models/casinoCategory";

/**
 * Every active category for a lookup source in priority order.
 * Lowest number first and `name` breaks the tie.
 */
const useCasinoCategories = (enabled = true) => {
  const { data, error, isLoading } = useFirestore(
    enabled ? "/casinoCategoriesV2" : null,
    casinoCategory.array(),
    { keyPath: "id" },
  );

  const categories = useMemo(
    () =>
      data
        ? data
            .filter((category) => category.status === "ACTIVE")
            .sort(
              (a, b) => a.priority - b.priority || a.name.localeCompare(b.name),
            )
        : [],
    [data],
  );

  return { categories, error, isLoading } as const;
};

export { useCasinoCategories };
